<template>
<div>
<user-top></user-top>
<div class="millia pb30">
<div class="ht tc mt50">完善个人资料</div>
<basic-info></basic-info>
<!--教育经历信息-->
<div class="ht01">
<b>教育经历</b>
<div  class="addBt" id="addEdu">添加教育经历</div>
</div>
<div class="hideInfo">
<edu-exp></edu-exp>
</div>

<!--工作经历信息-->
<div class="ht01">
<b>工作经历</b>
<div  class="addBt" id="addEdu">添加工作经历</div>
</div>
<div class="hideInfo">
<job-exp></job-exp>
</div>




<!--家庭成员信息-->
<div class="ht01">
<b>家庭成员</b>
<div  class="addBt" id="addEdu">添加家庭成员</div>
</div>
<div class="hideInfo">
<family-group></family-group>
</div>



</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop';
import BasicInfo from '@/components/BasicInfo';
import EduExp from '@/components/EduExp';
import JobExp from '@/components/JobExp';
import FamilyGroup from '@/components/FamilyGroup';
export default {
    name:'UserIntro',
    components:{
        UserTop,
        BasicInfo,
        EduExp,
        JobExp,
        FamilyGroup
    },
    data () {
        return{
            
        }
    },
    mounted() {      
        //添加教育经历/工作经历/家庭成员按钮效果
        var tag = document.getElementsByClassName("addBt");
        var tagContent = document.getElementsByClassName("hideInfo");
        for(var x=0;x<tag.length;x++){
            tag[x].index = x;//定义一个index属性对tag进行编号
            tag[x].onclick = function(){
                for(var i=0;i<tagContent.length;i++){
                    tagContent[i].style.display = "none";
                }
                tagContent[this.index].style.display = "block";//通过之前定义的index编号改变当前点击的样式
            }
        }           

        //时间选择
        // layui.use('laydate', function(){
        //     var laydate = layui.laydate;
        //     lay('.timeFlie').each(function(){
        //         laydate.render({
        //             elem:this,
        //             trigger:'click',
        //             type:'month',
        //             done:function(value,data,endData){ //监听日期被切换
        //             //直接给vue中的data赋值这样就会触发vue的自动绑定。
        //                 app.$data.info[this.elem[0].name]=value;
        //                 console.log(value);
        //             }
        //         });
        //     });
        // });
    },
    methods:{
    }
}
</script>
<style scoped>
.ht01{position:relative;padding:1rem 0;border-top:.1rem dotted #d0d0d0;}
.ht01 b{display:inline-block;font-weight:normal;font-size:1.6rem;line-height:3rem;}
.addBt{position:absolute;right:0;top:1.2rem;font-size:1.4rem;padding:.3rem .6rem;color:#fff;background:darkcyan;border-radius:.5rem;}
.hideInfo{padding:1rem 0 0 0;}
.hideInfo li{margin-bottom:1rem;position:relative;}
.hideInfo{display:none;}
</style>